<div class="subheader with-padding flgrow">
    <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-8">
            <div class="flmid relative">
                <div class="input-group flgrow">
                    <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}"
                      [(ngModel)]="searchTerm" autocomplete="off" (keyup.enter)="onSearchFilter()" />
                    <div class="input-group-append">
                      <button type="button" class="btn btn-primary" (click)="onSearchFilter()">
                        <em class="fa fa-search font17"></em>
                      </button>
                    </div>
                  </div>
            </div>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-6 pl-4">
            <ng-select placeholder="{{ 'lblStatus' | translate }}" [(ngModel)]="selectedStatus"
                (change)="StatusChange($event)">
                <ng-option *ngFor="let status of StatusList" [value]="status.id">
                    {{status.value}}
                </ng-option>
            </ng-select>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-6" *ngIf="isDmsSyncLabor">
            <ng-select placeholder="{{ 'lblDMSStatus' | translate }}" [(ngModel)]="selectedSync"
                (change)="SyncChange($event)">
                <ng-option *ngFor="let status of SyncList" [value]="status.id">
                    {{status.value}}
                </ng-option>
            </ng-select>
        </div>

        <div class="col-lg-2 col-md-3 col-sm-6" *ngIf="isDmsSyncLabor">
            <ng-select placeholder="{{ 'lblSource' | translate }}" [(ngModel)]="sourceName"
                (change)="SourceChange($event)">
                <ng-option *ngFor="let source of applicationSourceList" [value]="source.sourceId">
                    {{source.sourceName}}
                </ng-option>
            </ng-select>
        </div>
        <div class="col-auto ml-auto d-flex flex-sm-row flex-column justify-content-end align-items-center">
            <a class="ml-2 btn btn-outline-primary" href="javascript:void(0);" (click)="onRefresh()"
                aria-label="Center Align">
                <em class="fas fa-sync fa-lg"></em>
            </a>
            <button type="button" type="reset" class="ml-2 add-button btn btn-primary"
                aria-label="Center Align" *ngIf="userRoleRightsDetails.canAdd" (click)="onEdit(0)"
                translate>lblAddLabor</button>
        </div>
    </div>
</div>
<div class="container prel">
    <div class="row">
        <div class="c12">
            <div class="card mb-3">
                <div class="card-header d-flex justify-content-between" translate>
                    lblLabors
                    <div class="font16 fontbold">
                        <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
                        totalCount
                        }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
                    </div>
                </div>
                <div class="table-responsive max-h232" infinite-scroll [infiniteScrollDistance]="scrollDistance" 
                [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown($event)">
                    <table class="tablest1">
                        <thead>
                            <tr>
                                <th style="width:55px" scope="col" translate>#</th>
                                <th scope="col" style="width:50px" sortable="laborNo"
                                    (sort)="onSort($event)" translate>
                                    lblLaborNumber</th>
                                <th scope="col" sortable="name" (sort)="onSort($event)" translate>
                                    lblLaborName</th>
                                <th scope="col" sortable="makeName" (sort)="onSort($event)" translate>
                                    lblMakeName</th>
                                <th scope="col" sortable="fixedPrice" style="width:50px"
                                    (sort)="onSort($event)" translate >
                                    lblPrice</th>
                                <th scope="col" class="text-right" style="width: 10%" sortable="duration"
                                    (sort)="onSort($event)" translate>
                                    <span translate>lblDuration</span>
                                    (<span translate>lblInMinute</span>)
                                </th>
                                <th scope="col" class="text-center" translate *ngIf="isDmsSyncLabor">lblSource</th>
                                <th scope="col" style="width:50px" sortable="updatedDate"
                                    (sort)="onSort($event)" translate>lblUpdatedDate</th>
                                <th scope="col" style="width:50px" sortable="dmsSyncDate"
                                    (sort)="onSort($event)" translate *ngIf="isDmsSyncLabor">
                                    lbllastSyncdate</th>
                                <th class="text-center" scope="col" translate>lblActive</th>
                                <th scope="col" translate class="text-center">lblAction</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="laborList?.length>0; else load_NotFound_Template">
                                <tr *ngFor="let item of laborList; let i=index"
                                    [ngClass]="{'clrRed' : item.dmsSyncStatus == 0}">
                                    <td>{{ item.rowNumber }}</td>
                                    <td>
                                        <ngb-highlight [result]="item.laborNo">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="item.name">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <div class="imgWid">
                                            <img af-brand-logo [data-code]="item.logo" data-type="BRAND"
                                                class="{{ item.logo }}-icon brandicon"
                                                alt="not found" />
                                        </div>
                                    </td>
                                    <td >
                                        <ngb-highlight [result]="item.fixedPrice">
                                        </ngb-highlight>
                                    </td>
                                    <td class="text-right">
                                        <ngb-highlight [result]="item.duration" >
                                        </ngb-highlight>
                                      </td>
                    
                                    <td *ngIf="isDmsSyncLabor">
                                        <ngb-highlight
                                            [ngClass]="item.sourceType ? 'flmid sourceBox rounded-0 justify-content-center' : ''"
                                            [result]="item.sourceType">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        {{ item.updatedDate | date:'short'}}
                                    </td>
                                    <td *ngIf="isDmsSyncLabor">
                                        {{ item.dmsSyncDate | date:'short'}}
                                    </td>
                                    <td class="text-center">
                                        <em class="fas fa-check" *ngIf="item.isActive == true"></em>
                                        <em class="fas fa-close" *ngIf="item.isActive == false"></em>
                                    </td>

                                    <td class="nowrap text-center">
                                        <ng-container *ngIf="isDmsSyncLabor">
                                            <a class="btn btn-ico"
                                                ngbTooltip="{{ 'lblSyncToDMS' | translate }}"
                                                tooltipClass="custom-revert"
                                                [class.invisible]="item.dmsSyncStatus != 0"
                                                (click)="onSyncToDms(item.id)">
                                                <em class="fas fa-sync fa-lg  "></em>
                                            </a>
                                            <span class="ico-div"
                                                [class.invisible]="item.dmsSyncStatus != 0"></span>
                                            <a class="btn btn-ico"
                                                ngbTooltip="{{ 'lblDMSSyncFailedlog' | translate }}"
                                                tooltipClass="custom-revert"
                                                [class.invisible]="item.dmsSyncStatus != 0"
                                                (click)="viewException(item.id)">
                                                <em class="fas fa-clipboard-list fa-lg  "></em>
                                            </a>
                                            <span class="ico-div"
                                                [class.invisible]="item.dmsSyncStatus != 0"></span>
                                        </ng-container>
                                        <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}"
                                            tooltipClass="custom-revert"
                                            *ngIf="userRoleRightsDetails.canEdit" (click)="onEdit(item.id)">
                                            <em class="fas fa-pencil-alt fa-lg"></em>
                                        </a>
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-template #load_NotFound_Template>
                                <tr>
                                    <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

</div>